import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';
import { useContextProps, ListBox as ListBox$1 } from 'react-aria-components';
import { mergeClassNames } from '../utils/mergeClassNames.es.js';

const listBox = "_list-box_1ho7y_1";
const styles = {
	listBox: listBox
};

const ListBoxContext = createContext({});
const ListBox = (props) => {
  const [contextProps] = useContextProps(props, null, ListBoxContext);
  const { className, size = "medium" } = contextProps, otherProps = __rest(contextProps, ["className", "size"]);
  return jsx(ListBox$1, Object.assign({}, otherProps, { className: (renderProps) => mergeClassNames([styles.listBox, className], renderProps), "data-size": size }));
};

export { ListBox, ListBoxContext };
//# sourceMappingURL=ListBox.es.js.map
